import {getEventTitle, getFormattedLocation, getTaxConfig} from '@wix/wix-events-commons-statics'
import {withTranslation} from '@wix/yoshi-flow-editor'
import {getDatesInformation} from '../../../selectors/dates'
import {DetailsPageAppProps} from '../../app/interfaces'
import {connect} from '../../runtime-context/context'
import {getOrderedTickets} from '../../../selectors/placed-order'
import {getSortedSelectedTickets} from '../../../selectors/selected-tickets'
import {OrderSummaryRuntimeProps} from './interfaces'
import {OrderSummary as OrderSummaryPresentation} from './order-summary'

const mapRuntimeToProps = ({state}: DetailsPageAppProps): OrderSummaryRuntimeProps => {
  const {event, tickets} = state

  return {
    eventTitle: getEventTitle(event),
    eventDate: getDatesInformation(state).fullDate,
    eventLocation: getFormattedLocation(event),
    tickets: getOrderedTickets(getSortedSelectedTickets(state), tickets),
    taxConfig: getTaxConfig(event),
  }
}

export const OrderSummary = connect<{}, OrderSummaryRuntimeProps>(mapRuntimeToProps)(
  withTranslation()(OrderSummaryPresentation),
)
